<template>
    <div class="Information">
        <div class="row">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-4">
                        <div class="record-section">
                            <h4>Enrollment Information:</h4>
                            <p>
                                <span class="bold">Program Name: </span> {{ ChildRecordData.SubProgram.Name }}

                            </p>
                            <p>
                                <span class="bold">Referral Date: </span>
                                <DateEditorRequest v-bind:old-value="ChildRecordData.StartDate"
                                                   v-bind:record-id="ChildRecordData.Id"
                                                   v-bind:edit-mode="EditMode"
                                                   data-label="Start Date"
                                                   property-name="Date"
                                                   update-method="Wraparound/Clients/UpdateStartDate"
                                                   required="true"
                                                   warning-notice="Modifying the referral date may affect other records, and reports that have already been generated should be updated."
                                                   :global-update="true"
                                                   :chart-id="ChildRecordData.Id"
                                                   edit-permission="Wraparound/Clients/UpdateStartDate" />
                            </p>
                            <p>
                                <span class="bold">Discharge Info: </span>
                                <DischargeEditor v-bind:old-end-date="ChildRecordData.EndDate"
                                                 v-bind:old-reason="ChildRecordData.SubProgramDischargeReason"
                                                 v-bind:record-id="ChildRecordData.Id"
                                                 record-id-name="ClientSubProgramMembershipID"
                                                 v-bind:edit-mode="EditMode"
                                                 data-label="Termination Info"
                                                 discharge-method="Foster/Membership_FosterResourceFamily_ClientSubProgramMembership/TerminateSubProgramMembership"
                                                 revert-method="Foster/Membership_FosterResourceFamily_ClientSubProgramMembership/RevertSubProgramTermination"
                                                 v-bind:options="GetSubProgramTerminationReasons"
                                                 discharge-language="Terminate"
                                                 :chart-id="ChildRecordData.Id"
                                                 edit-permission="Administrator" />
                            </p>
                            <p>
                                <span class="bold">Welligent Program Round: </span>
                                <IntegerEditor v-bind:old-value="ChildRecordData.WelligentProgramRound"
                                               v-bind:record-id="ChildRecordData.Id"
                                               v-bind:edit-mode="EditMode"
                                               data-label="Welligent Program Round"
                                               property-name="WelligentProgramRound"
                                               update-method="Residential/Clients/UpdateWelligentID"
                                               :global-update="true"
                                               edit-permission="Wraparound.ClientInfo.Edit.Welligent" />
                            </p>
                            <p>
                                <span class="bold">Days in Program: </span><span>{{ ChildRecordData.DaysInSubProgram }}</span>
                            </p>
                        </div>

                    </div>

                    <div class="col-md-4">
                        <div class="record-section">
                            <h4>Important Dates:</h4>
                            <p>
                                <span class="bold">First Contact Date: </span>
                                <DateEditor v-bind:old-value="ChildRecordData.FirstContactDate"
                                            v-bind:record-id="ChildRecordData.Id"
                                            v-bind:edit-mode="EditMode"
                                            data-label="First Contact Date"
                                            property-name="FirstContactDate"
                                            update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                            :global-update="true"
                                            :chart-id="ChildRecordData.Id" />
                            </p>
                            <p>
                                <span class="bold">First Clinical Contact: </span>
                                <DateEditor v-bind:old-value="ChildRecordData.FirstClinicalContactDate"
                                            v-bind:record-id="ChildRecordData.Id"
                                            v-bind:edit-mode="EditMode"
                                            data-label="First Clinical Contact Date"
                                            property-name="FirstClinicalContactDate"
                                            update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                            :global-update="true"
                                            :chart-id="ChildRecordData.Id" 
                                            edit-permission="MentalHealth.CreateClinicalDocuments"/>
                            </p>
                            <p>
                                <span class="bold">First Face-to-Face Date: </span>
                                <DateEditor v-bind:old-value="ChildRecordData.FirstFaceToFaceDate"
                                            v-bind:record-id="ChildRecordData.Id"
                                            v-bind:edit-mode="EditMode"
                                            data-label="First Face to Face Date"
                                            property-name="FirstFaceToFaceDate"
                                            update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                            :global-update="true"
                                            :chart-id="ChildRecordData.Id" />
                            </p>

                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="record-section">
                            <h4>Running Summary:</h4>
                            <TextAreaEditor v-bind:old-value="ChildRecordData.RunningSummary"
                                            v-bind:record-id="ChildRecordData.Id"
                                            v-bind:edit-mode="EditMode"
                                            data-label="Running Summary"
                                            property-name="RunningSummary"
                                            update-method="Foster/FosterClients/UpdateRunningSummary"
                                            required="false"
                                            :global-update="true"
                                            :chart-id="ChildRecordData.Id" />
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col col-md-12">
                <div class="record-section">
                    <h4>Living Situation:</h4>
                    <LivingSituationEditor :situation-data="ChildRecordData.LivingSituations"
                                           :chart-id="ChildRecordData.Id"
                                           :edit-mode="EditMode" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col col-md-6">
                <div class="record-section">
                    <h4>Population:</h4>
                    <ProgramServiceAssignmentEditor :edit-mode="EditMode"
                                                    view-permission-requirement="Wraparound.ProgramServices.View"
                                                    edit-permission="Wraparound.ProgramServices.Edit"
                                                    :sub-program-id="ChildRecordData.SubProgramID"
                                                    rate-supplement-label="Special Supervision Rate (if applicable)"
                                                    custom-rate-label="CUSTOM RATE (REQUIRED)"
                                                    :chart-id="ChildRecordData.Id"
                                                    :field-data="ChildRecordData.ProgramServices" />
                </div>
            </div>
            
            <div class="col col-md-6">
                <div class="record-section">
                    <h4>Wrap Phases:</h4>
                    <SingleMembershipEditorRequest :fields="[{name: 'Name', title: 'PHASE'}, {name: 'StartDate', title: 'STARTED', callback: 'formatDate|MM/DD/YY'}, {name: 'EndDate', title: 'ENDED', callback: 'formatDate|MM/DD/YY|N/A'}]"
                                                   :field-data="ChildRecordData.ClientPhases"
                                                   :chart-id="ChildRecordData.Id"
                                                   :edit-mode="EditMode"
                                                   select-label="Phase Name:"
                                                   options-type="Data"
                                                   :options-method="[{text:'Engagement and Planning',value:'Engagement and Planning'},{text:'Implementation',value:'Implementation'},{text:'Transition',value:'Transition'}]"
                                                   :options-method-record-id="ChildRecordData.Id"
                                                   add-record-method="Wraparound/Phase/AddFirstPhase"
                                                   add-record-record-property-name="Name"
                                                   :add-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.Id}"
                                                   add-record-modal-title="Assign Initial Wrap Phase at Referral"
                                                   transfer-record-method="Wraparound/Phase/TransferPhase"
                                                   transfer-record-record-property-name="Name"
                                                   :transfer-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.Id}"
                                                   transfer-record-modal-title="Transfer to New Phase"
                                                   transfer-record-effective-date-property-name="EffectiveDate"
                                                   delete-record-method="Wraparound/Phase/DeletePhase"
                                                   :delete-record-additional-payload="{Id: ChildRecordData.Id}"
                                                   delete-record-modal-title="Delete Current Wrap Phase"
                                                   delete-record-modal-text="NOTICE: You are about to delete this child's current Wraparound Phase.  If there was a previous Phase assigned, it will be re-activated." />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col col-md-6">
                <div class="record-section">
                    <h4>Misc:</h4>
                    <p>
                        <span class="bold">Contact Preference: </span>
                        <SelectEditorRequest v-bind:old-value="ChildRecordData.ContactStatus"
                                             v-bind:old-value-text="ChildRecordData.ContactStatus"
                                             v-bind:record-id="ChildRecordData.Id"
                                             v-bind:edit-mode="EditMode"
                                             data-label="Contact Preference"
                                             property-name="ContactStatus"
                                             update-method="Wraparound/Clients/UpdateClientSubProgramMembership"
                                             required="true"
                                             v-bind:options="[{text: 'Unspecified', value: ''},{text: 'Social Distancing Preferred', value: 'Social Distancing Preferred'},{text: 'Modified Services', value: 'Modified Services'},{text: 'In-Person Contact Requested', value: 'In-Person Contact Requested'}]"
                                             :chart-id="ChildRecordData.Id" />
                    </p>
                    <p>
                        <span class="bold">Region of Origin: </span>
                        <SelectEditorRequest v-bind:old-value="ChildRecordData.RegionOfOrigin"
                                             v-bind:old-value-text="ChildRecordData.RegionOfOrigin"
                                             v-bind:record-id="ChildRecordData.Id"
                                             v-bind:edit-mode="EditMode"
                                             data-label="Region of Origin"
                                             property-name="RegionOfOrigin"
                                             update-method="Wraparound/Clients/UpdateClientSubProgramMembership"
                                             required="true"
                                             v-bind:options="[{text: 'Unspecified', value: 'Unspecified'},{text: 'West Corridor (Corona/Norco/Elsinore)', value: 'West Corridor (Corona/Norco/Elsinore)'},{text: 'Metro (Jurupa/Riverside)', value: 'Metro (Jurupa/Riverside)'},{text: 'Valley (Moreno Valley/Perris)', value: 'Valley (Moreno Valley/Perris)'},{text: 'South West (Temecula/Hemet)', value: 'South West (Temecula/Hemet)'},{text: 'Mid County (Banning/Cathedral City/Palm Springs)', value: 'Mid County (Banning/Cathedral City/Palm Springs)'},{text: 'Desert (Indio/Blythe)', value: 'Desert (Indio/Blythe)'},{text: 'Out of County', value: 'Out of County'},{text: 'Out of State', value: 'Out of State'}]"
                                             :chart-id="ChildRecordData.Id" />
                    </p>
                    <p>
                        <span class="bold">Primary Language Spoken: </span>
                        <SelectEditor v-bind:old-value="ChildRecordData.PrimaryLanguageSpoken"
                                      v-bind:old-value-text="ChildRecordData.PrimaryLanguageSpoken"
                                      v-bind:record-id="ChildRecordData.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="Primary Language Spoken"
                                      property-name="PrimaryLanguageSpoken"
                                      update-method="Wraparound/Clients/UpdateClientSubProgramMembership"
                                      :chart-id="ChildRecordData.Id"
                                      v-bind:options="PrimaryLanguageSpokenOptions" />
                    </p>
                    <p>
                        <span class="bold">CWS Identifier: </span>
                        <StringEditor v-bind:old-value="ChildRecordData.GovernmentSystemIdentifier"
                                      v-bind:record-id="ChildRecordData.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="CWS Identifier"
                                      property-name="GovernmentSystemIdentifier"
                                      update-method="Wraparound/Clients/UpdateClientSubProgramMembership"
                                      :chart-id="ChildRecordData.Id" />
                    </p>
                    <p>
                        <span class="bold">Client Has Disability: </span>
                        <SelectEditorRequest v-bind:old-value="ChildRecordData.HasDisability"
                                             v-bind:old-value-text="ChildRecordData.HasDisability == true ? 'Yes' : 'No'"
                                             v-bind:record-id="ChildRecordData.Id"
                                             v-bind:edit-mode="EditMode"
                                             data-label="Client Has Disability"
                                             property-name="HasDisability"
                                             update-method="Wraparound/Clients/UpdateClientSubProgramMembership"
                                             required="false"
                                             v-bind:options="[{text: '', value: ''},{text: 'Yes', value: true},{text: 'No', value: false}]"
                                             :chart-id="ChildRecordData.Id" />
                    </p>
                    <p>
                        <span class="bold">RUHS RU Override: </span>
                        <SelectEditorRequest v-bind:old-value="ChildRecordData.BillingContractCodeOverride"
                                             v-bind:old-value-text="ChildRecordData.BillingContractCodeOverride"
                                             v-bind:record-id="ChildRecordData.Id"
                                             v-bind:edit-mode="EditMode"
                                             data-label="RUHS RU Override"
                                             property-name="BillingContractCodeOverride"
                                             update-method="Wraparound/Clients/UpdateClientSubProgramMembership"
                                             required="false"
                                             edit-permission="Administrator"
                                             v-bind:options="[{text: '', value: ''},{text: '33H501', value: '33H501'},{text: '33JE01', value: '33JE01'}]"
                                             :chart-id="ChildRecordData.Id" />
                    </p>
                </div>
            </div>
            <div class="col col-md-6">
                <div class="record-section">
                    <h4>School:</h4>
                    <SchoolDisplayAndEdit :edit-mode="EditMode"
                                          :global-update="true"
                                          get-endpoint="Residential/Clients/GetSchoolMemberships"
                                          :get-payload="{Id: ChildRecordData.Id }"
                                          add-edit-endpoint="Residential/Clients/AddOrUpdateSchoolMembership"
                                          :add-edit-payload="{ClientSubProgramMembershipID: ChildRecordData.Id}"
                                          delete-endpoint="Residential/Clients/DeleteSchoolMembership"
                                          :delete-payload="{Id: ChildRecordData.Id}"
                                          :common-schools="[]" />
                </div>
            </div>

        </div>
        <div class="row">
            <div class="col">
                <div class="record-section-row">
                    <h4>Service Frequency:</h4>
                    <ServiceFrequency :chart-id="ChildRecordData.Id" :edit-mode="EditMode && CheckPermission('Wraparound.ServiceFrequency.Edit')" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="record-section-row">
                    <h4>Acuity:</h4>
                    <Acuity :chart-id="ChildRecordData.Id" :edit-mode="EditMode && CheckPermission('Wraparound.ClientAcuity.Edit')" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col col-md-4">
                <div class="record-section">
                    <h4>Measures:</h4>
                    <p>
                        <span class="bold">Intake Measures Completed: </span>
                        <DateEditor v-bind:old-value="ChildRecordData.IntakeMeasuresCompletedDate"
                                    v-bind:record-id="ChildRecordData.Id"
                                    v-bind:edit-mode="EditMode"
                                    data-label="Intake Measures Completion Date"
                                    property-name="IntakeMeasuresCompletedDate"
                                    update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                    :global-update="true"
                                    :chart-id="ChildRecordData.Id"
                                    edit-permission="Clients.UpdateMeasuresDates" />
                    </p>
                    <p>
                        <span class="bold">3 Month Completed: </span>
                        <DateEditor v-bind:old-value="ChildRecordData.ThreeMonthMeasuresCompletedDate"
                                    v-bind:record-id="ChildRecordData.Id"
                                    v-bind:edit-mode="EditMode"
                                    data-label="3 Month Measures Completion Date"
                                    property-name="ThreeMonthMeasuresCompletedDate"
                                    update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                    :global-update="true"
                                    :chart-id="ChildRecordData.Id"
                                    edit-permission="Clients.UpdateMeasuresDates" />
                    </p>
                    <p>
                        <span class="bold">9 Month Completed: </span>
                        <DateEditor v-bind:old-value="ChildRecordData.NineMonthMeasuresCompletedDate"
                                    v-bind:record-id="ChildRecordData.Id"
                                    v-bind:edit-mode="EditMode"
                                    data-label="9 Month Measures Completion Date"
                                    property-name="NineMonthMeasuresCompletedDate"
                                    update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                    :global-update="true"
                                    :chart-id="ChildRecordData.Id"
                                    edit-permission="Clients.UpdateMeasuresDates" />
                    </p>
                    <p>
                        <span class="bold">Discharge Measures Completed: </span>
                        <DateEditor v-bind:old-value="ChildRecordData.DischargeMeasuresCompletedDate"
                                    v-bind:record-id="ChildRecordData.Id"
                                    v-bind:edit-mode="EditMode"
                                    data-label="Discharge Measures Completion Date"
                                    property-name="DischargeMeasuresCompletedDate"
                                    update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                    :global-update="true"
                                    :chart-id="ChildRecordData.Id"
                                    edit-permission="Clients.UpdateMeasuresDates" />
                    </p>
                </div>
            </div>
            <div class="col col-md-8">
                <div class="record-section">
                    <!--<ProblemsList :chart-id="ChildRecordData.Id" :edit-mode="EditMode" />-->
                    <ProblemsListEditor :chart-id="ChildRecordData.Id" :edit-mode="EditMode" />
                </div>
            </div>
        </div>
        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" permission="Wraparound.ClientProgram.Edit" />
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import DateEditor from '../../../Core/ItemEditors/DateEditor.vue';
    import DateEditorRequest from '../../../Core/ItemEditors/DateEditorRequest.vue';
    import StringEditor from '../../../Core/ItemEditors/StringEditor.vue';
    import IntegerEditor from '../../../Core/ItemEditors/IntegerEditor.vue';
    import SelectEditor from '../../../Core/ItemEditors/SelectEditor.vue';
    import SelectEditorRequest from '../../../Core/ItemEditors/SelectEditorRequest.vue';
    import TextAreaEditor from '../../../Core/ItemEditors/TextAreaEditor.vue';
    import DischargeEditor from '../../../Core/ItemEditors/DischargeEditor.vue';
    import SingleMembershipEditor from '../../../Core/ItemEditors/SingleMembershipEditor.vue';
    import SingleMembershipEditorRequest from '../../../Core/ItemEditors/SingleMembershipEditorRequest.vue';
    import LivingSituationEditor from '../../../Core/ItemEditors/LivingSituationEditor.vue';
    import SchoolDisplayAndEdit from '../../../Core/ItemEditors/SchoolDisplayAndEdit.vue';
    import ServiceFrequency from "./ServiceFrequency.vue";
    import Acuity from "./Acuity.vue";
    import ProgramServiceAssignmentEditor from '../../../Core/ItemEditors/ProgramServiceAssignmentEditor.vue';
    //import ProblemsList from '../../../Core/ItemEditors/ProblemsList.vue';
    import ProblemsListEditor from '../../../MentalHealth/Editors/ProblemsListEditor.vue';
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    export default {
        props: [
            'ChildRecordData'
        ],
        data: function () {
            return {
                Agencies: [],
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            },
            GetAgencies() {
                this.$MasterAPI.ExecuteRequest("GET", "Foster/FosterClients/GetAgencies", {}, this.GetAgenciesSuccess, () => { }, false);
            },
            GetAgenciesSuccess(response) {
                this.Agencies = response.data.data;
                for (var i = 0; i < this.Agencies.length; i++) {
                    this.Agencies[i].text = this.Agencies[i].Name;
                    this.Agencies[i].value = this.Agencies[i].Id;
                }
            }
        },
        components: {
            DateEditor,
            DateEditorRequest,
            StringEditor,
            DischargeEditor,
            SingleMembershipEditor,
            SingleMembershipEditorRequest,
            TextAreaEditor,
            IntegerEditor,
            SelectEditorRequest,
            EditMode,
            LivingSituationEditor,
            SchoolDisplayAndEdit,
            ServiceFrequency,
            Acuity,
            SelectEditor,
            ProgramServiceAssignmentEditor,
            //ProblemsList,
            ProblemsListEditor
        },
        mounted() {
            this.GetAgencies();
        },
        computed: {
            GetSubProgramTerminationReasons: function () {
                let subprogram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.ChildRecordData.SubProgramID);
                let returnObj = [];
                if (subprogram.DischargeReasons.length > 0) {
                    subprogram.DischargeReasons.forEach(function (item) {
                        returnObj.push({ text: item.Label, value: item.Id, grouping: item.Grouping });
                    })
                }
                return returnObj;
            },
            OptionsPlacementType: function () {
                return this.$store.state.Options.PlacementType;
            },
            ProgramServicesCensus: function () {
                return this.ChildRecordData.ProgramServices.filter(ps => ps.ProgramService.ServiceType == "Census");
            },
            PrimaryLanguageSpokenOptions: function () {
                return this.$store.state.Options.PrimaryLanguageSpoken;
            },
        }
    }
</script>

<style scoped>
</style>